import { render } from "./audioRecorder.vue?vue&type=template&id=a66aa66e"
import script from "./audioRecorder.vue?vue&type=script&lang=js"
export * from "./audioRecorder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__